<div id="teaching" class="teaching bg-light mt-5 pt-5">
    <div class="container">
        <div class="row mt-3">
            <div class="col-12">
                <h1 class="fw-bold title ps-3 display-5">Teaching</h1>
            </div>
        </div>
    </div>
    <div class="container mt-5">
        <div class="row">
            <div class="col-12">

                <div *ngFor="let item of list; let i=index"
                    class="teching-class bg-light lead mb-4">
                    <div class="me-4 fw-bold classname text-secondary">{{item.title}}</div>
                    <div class="content">{{item.content}}</div>
                </div>


                <!-- <ul class="list-group px-0">
                    <li class="list-group-item bg-light border-0 px-0 mb-3 teching-class"
                        *ngFor="let item of list">
                        <div class="me-4 fw-bold classname text-secondary">{{item.title}}</div>
                        <div class="content">{{item.content}}</div>
                    </li>
                </ul> -->
            </div>
        </div>
    </div>
</div>